import { Paper } from '@mui/material';
import React from 'react';
import { Page } from '../../components/Page/Page.tsx';

export const PrivacyPolicy = () => {
	const termsPdfUrl = '/polityka.pdf';
	return (
		<Page title="Polityka prywatności" theme="light">
			<Paper className="lessons__paper paper">
				<div className="singleLesson__wrapper">
					<p>
						<a href={termsPdfUrl} target="_blank" rel="noopener noreferrer">
							Aktualna Polityka Prywatności Licytapki
						</a>
					</p>
				</div>
			</Paper>
		</Page>
	);
};
